import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import accountApi from '../../api/accountApi';
import isEmail from 'validator/es/lib/isEmail';
import TextInput from '../../../common/component/form/TextInput';
import '../../style/PasswordReset.less';

function PasswordResetRequest() {
    const [t] = useTranslation();
    const [success, setSuccess] = useState(false);
    const [infoText, setInfoText] = useState('PasswordReset.INFO_REQUEST');
    const [email, setEmail] = useState(null);
    const [isValidated, setIsValidated] = useState(false);
    const [validation, setValidation] = useState(true);

    useEffect(() => {
        if (isValidated) {
            validate();
        }
    }, [email]);

    function sendPasswordResetRequest() {
        if (validate()) {
            accountApi.requestPasswordReset(email).then((res) => {
                if (res.data.success) {
                    setSuccess(true);
                    setInfoText('PasswordReset.MAIL_SENT');
                } else {
                    setSuccess(false);
                }
            }).catch(() => {
                setSuccess(false);
            });
        }
    }

    function validate() {
        setIsValidated(true);
        setValidation(!!email && isEmail(email));

        // Check if password is valid
        return !!email && isEmail(email);
    }

    return (
        <>
            <div className="login-wrapper">
                <div className="mr-4 ml-4">
                    <div className="card">
                        <div className="card-body big-label spelling">
                            <h1>{t('PasswordReset.REQUEST')}</h1>
                            <p id="password-reset-text" className="text-center mx-auto">{t(infoText)}</p>
                            {
                                !success &&
                                <div className="mb-4">
                                    <TextInput
                                        label={t('Account.EMAIL')}
                                        value={email}
                                        onChange={value => setEmail(value)}
                                        required={true}
                                        isValid={validation}
                                        errorMessage={!validation && !!email ? t('Validation.INVALID_EMAIL') : null}
                                    />

                                    <div className="button-footer">
                                        <button className="btn btn-primary" onClick={sendPasswordResetRequest}>{t('PasswordReset.REQUEST_PASSWORD')}</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordResetRequest;
